import React, {
  useEffect,
  useState
} from "react";

import {
  useLocation
} from "react-router-dom";


function BackToTopButton() {

  const {
    pathname
  } = useLocation();

  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const isExcludedPage =
    pathname === "/login" ||
    pathname.startsWith("/admin");


  useEffect(() => {

    if (isExcludedPage) {
      setIsVisible(false);
      return undefined;
    }


    const updateVisibility = () => {
      setIsVisible(
        window.scrollY > 600
      );
    };


    updateVisibility();

    window.addEventListener(
      "scroll",
      updateVisibility,
      {
        passive: true
      }
    );


    return () => {
      window.removeEventListener(
        "scroll",
        updateVisibility
      );
    };

  }, [
    pathname,
    isExcludedPage
  ]);


  if (isExcludedPage) {
    return null;
  }


  const handleGoUp = () => {

    const reduceMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;


    window.scrollTo({
      top: 0,
      behavior:
        reduceMotion
          ? "auto"
          : "smooth"
    });

  };


  return (
    <button
      type="button"
      className={`public-back-to-top ${
        isVisible
          ? "public-back-to-top-visible"
          : ""
      }`}
      onClick={handleGoUp}
      aria-label="Go back to the top of the page"
      title="Go Up"
    >

      <span
        className="public-back-to-top-arrow"
        aria-hidden="true"
      >
        ↑
      </span>

      <span>Go Up</span>

    </button>
  );

}


export default BackToTopButton;